// extracted by mini-css-extract-plugin
export default {"StateTiny":"DymanicStateDisplay_StateTiny__e4oHs","StateSmall":"DymanicStateDisplay_StateSmall__yepS-","StateMedium":"DymanicStateDisplay_StateMedium__X0yMC"};